import * as React from "react";
import { Button, Checkbox, Dialog, FormControlLabel } from "@mui/material";
import { useDialogState } from "../../common/DialogButton";
import { CancelableDialogBody } from "../../user/CancelableDialogBody";
import { messages } from "../../../utils/i18n/i18n";
import { useTranslation } from "../../../utils/i18n/lang";

interface Props {
    includeResultsWithoutBibPass: boolean;
    onIncludeResultsWithoutBibPassChange: (checked: boolean) => void;
}

export const LiveResultsIndividualsSettings = (p: Props) => {
    const dialogState = useDialogState();
    const m = useTranslation(msg);

    return (
        <>
            <Button
                size="small"
                variant="text"
                onClick={() => {
                    dialogState.setOpen(true);
                }}
            >
                {m.settingsBtn}
            </Button>
            <Dialog
                open={dialogState.isOpen}
                onClose={dialogState.close}
                fullWidth
                maxWidth="sm"
            >
                <CancelableDialogBody
                    onCancel={dialogState.close}
                    title={m.settingsTitle}
                >
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={p.includeResultsWithoutBibPass}
                                onChange={(_, checked) => {
                                    p.onIncludeResultsWithoutBibPassChange(
                                        checked
                                    );
                                }}
                            />
                        }
                        label={m.includeResultsWithoutBibPass}
                    />
                </CancelableDialogBody>
            </Dialog>
        </>
    );
};

const msg = messages(
    {
        settingsBtn: "Settings",
        settingsTitle: "Live results settings",
        includeResultsWithoutBibPass: "Show results even without any bib pass",
    },
    {
        cs: {
            settingsBtn: "Nastavení",
            settingsTitle: "Nastavení live výsledků",
            includeResultsWithoutBibPass:
                "Zobrazit i výsledky bez jakéhokoliv průchodu čipem",
        },
    }
);
